const moduleMargins = {
    xxs: '24px',
    xs: ['20px', null, '32px', '80px'],
    sm: ['32px', null, '56px', '80px'],
    md: ['80px', null, '96px', '112px'],
};

export default moduleMargins;
